import { render, staticRenderFns } from "./SynaqMailboxes.vue?vue&type=template&id=0ce77767&scoped=true&"
import script from "./SynaqMailboxes.vue?vue&type=script&lang=js&"
export * from "./SynaqMailboxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce77767",
  null
  
)

export default component.exports